import { Component, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { FieldType } from '@ngx-formly/material/form-field';

@Component({
  selector: 'formly-field-mat-input',
  templateUrl: './custom-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomInputComponent extends FieldType<any> {
  @ViewChild(MatInput) formFieldControl!: MatInput;

  get type() {
    return this.to.type || 'text';
  }
}
